<script lang="ts" setup>
const { contacts } = storeToRefs(useSiteStore());

const isShopSupportModal = ref(false);
</script>

<template>
  <div class="contacts-block">
    <button
      v-if="contacts.phone"
      class="font-bold"
      name="open-support-modal"
      type="button"
      @click="isShopSupportModal = true"
    >
      {{ contacts.phone }}
    </button>

    <a
      v-if="contacts.tgLink"
      :href="contacts.tgLink"
      class="flex justify-center items-center gap-2 text-xs"
      rel="nofollow noopener"
      target="_blank"
    >
      <SvgoDialog
        :font-controlled="false"
        class="contacts-block__dialog-icon"
        filled
      />
      Задать вопрос в Telegram
    </a>

    <ContactsModal v-model:is-show-support-modal="isShopSupportModal" />
  </div>
</template>

<style lang="scss" scoped>
.contacts-block {
  // display will come from the parent component
  flex-direction: column;
  gap: 8px;
  align-items: center;

  &__dialog-icon {
    width: 12px;
    height: 12px;
  }
}
</style>
